import { Reminder } from '../EnumTypes/ActionEnumTypes';
import { Connector } from 'Modules/ReminderModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';

const init = () => ({
    type: Reminder.GET_REMINDER_LIST_INIT,
});

const success = (data) => ({
    type: Reminder.GET_REMINDER_LIST_SUCCESS,
    payload: {
        data
    }
});

const failure = () => ({
    type: Reminder.GET_REMINDER_LIST_FAILURE,
});

const getRemindersList = (main = false) => async (dispatch) => {
    dispatch(init());
    try {
        dispatch(ViewManagementModule.Actions.showLoader());
        const { data } = await Connector.getRemindersList(main);
        dispatch(success(data));
        dispatch(ViewManagementModule.Actions.hideLoader());
    } catch (err) {
        dispatch(ViewManagementModule.Actions.hideLoader());
        dispatch(failure());
    }
};

export default getRemindersList;
